import * as types from '../mutation-types';
import MonitorsAPI from '../../api/monitors';

export const state = {
  records: [],
  inbox_id: 0,
  userConv: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  tableData: {},
  agentData: {},
  timeData: [],
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getUserCount($state) {
    return $state.records;
  },
  getUserConv($state) {
    return $state.userConv;
  },
  getTableData($state) {
    return $state.tableData;
  },
  getAgentData($state) {
    return $state.agentData;
  },
  getTimeData($state) {
    return $state.timeData;
  },
};

export const actions = {
  updateState: async ({}, data) => {
    try {
      let response = await MonitorsAPI.updateState(data);
    } catch (error) {
      throw new Error(error);
    }
  },
  updateUserState: async ({}, data) => {
    try {
      let response = await MonitorsAPI.updateUserState(data);
    } catch (error) {
      throw new Error(error);
    }
  },
  getUserData: async ({ state }, data) => {
    try {
      let response = await MonitorsAPI.getUserData(data);
      response.data.forEach((val, index) => {
        let time = parseInt(val.user_keep, 10);
        response.data[index].user_keep = time;
      });
      state.records = response.data;
    } catch (error) {
      throw new Error(error);
    }
  },
  setInbox: ({ state }, id) => {
    state.inbox_id = id;
  },
  updatePresence: async ({}, data) => {
    // commit(types.default.UPDATE_AGENTS_PRESENCE, data);
    state.records.forEach((element, index) => {
      if (data.users[element.id]) {
        state.records[index].availability_status = data.users[element.id];
      } else {
        state.records[index].availability_status = 'offline';
      }
      const user_keep = data.user_keep;
      if (user_keep && user_keep[element.id]) {
        let time = parseInt(user_keep[element.id], 10) || 0;
        state.records[index].user_keep = time;
      }
    });
  },
  setMonitor: ({ state }, res) => {
    if (state.inbox_id && state.inbox_id !== 0) {
      const data = res[state.inbox_id];
      // commit(types.default.UPDATE_MONITOR, data);
      let user_count = data.user_count;
      let user_keep = data.user_keep;
      let user_resolved = data.user_resolved;
      state.records.forEach((item, index) => {
        if (user_count[item.id]) {
          state.records[index].count = user_count[item.id];
        }
        if (user_keep[item.id]) {
          let availability = item.availability_status || 'offline';
          let time = parseInt(user_keep[item.id][availability], 10) || 0;
          state.records[index].user_keep = time;
        }
        if (user_resolved[item.id]) {
          state.records[index].resolved_count = user_resolved[item.id];
        }
      });
    } else if (state.inbox_id === 0 && Object.keys(res).length > 0) {
      // 没有选择渠道，只更新状态时间
      const data = res[Object.keys(res)[0]];
      let user_keep = data.user_keep;
      state.records.forEach((agent, index) => {
        if (user_keep[agent.id]) {
          let availability = agent.availability_status || 'offline';
          let time = parseInt(user_keep[agent.id][availability], 10) || 0;
          state.records[index].user_keep = time;
        }
      });
    }
  },
  setUserConv: async ({ state }, data) => {
    try {
      let response = await MonitorsAPI.getUserConv(data);
      state.userConv = response.data;
    } catch (error) {
      throw new Error(error);
    }
  },
  setTableData: async ({ state }, data) => {
    try {
      let response = await MonitorsAPI.getTableData(data);
      state.tableData = response.data;
    } catch (error) {
      throw new Error(error);
    }
  },
  setAgentData: async ({ state }, data) => {
    try {
      let response = await MonitorsAPI.getAgentData(data);
      state.agentData = response.data;
    } catch (error) {
      throw new Error(error);
    }
  },
  setTimeData: async ({ state }, data) => {
    try {
      let response = await MonitorsAPI.getTimeData(data);
      state.timeData = response.data;
    } catch (error) {
      throw new Error(error);
    }
  },
  setDialog: ({ state }, data) => {
    state.tableData = data.table_data;
    state.agentData = data.user_data;
  },
};

export const mutations = {
  [types.default.SET_AGENT_FETCHING_STATUS]($state, status) {
    $state.uiFlags.isFetching = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
